import { Box, Button, Drawer, IconButton, Tooltip, Typography, FormControlLabel, Checkbox, Autocomplete, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { DataGrid } from '@mui/x-data-grid'
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions'
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents'
import { DateTime } from 'luxon'
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

const PatientTypeList = [
    { patient_type: "Out Patient", value: "Outpatient" },
    { patient_type: "In Patient", value: "Inpatient" },
    { patient_type: "Self Patient", value: "Individual" }
]

const ModuleTypeList = () => {
    const investigations = localGetItem("Investigation_List")
        ? JSON.parse(localGetItem("Investigation_List"))
        : [];

    const baseList = [
        { patient_type: "OP", value: "OP" },
        { patient_type: "IP", value: "IP" },
        { patient_type: "OP & IP", value: "IP_OP" },
        { patient_type: "Laboratory", value: "LAB" },
        { patient_type: "Radiology", value: "RADIOLOGY" }
    ];

    const investigationList = investigations.map(item => ({
        patient_type: item,
        value: item
    }));

    return [...baseList, ...investigationList];
};

const ServiceConsolidateReport = (props) => {
    const [states, setStates] = useState({
        ServiceConsolidateData: [],
        FilterOpen: false,
        total_amount: 0,
        total_doc_share: 0,
        page: 0,
        pageSize: 10,
        isLoader: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
        doctorList: [],
        doctorName: [],
        patientType: [],
        ModuleType: [],
        serviceHeads: [],
        serviceType: [],
        serviceHeadServiceMap: {},
        serviceNames: [],
        isSharable: false,
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const history = useHistory()

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    useEffect(() => {
        const filterDetails = history?.location?.state;
        const hasFilter =  filterDetails?.fromDetailed;
        const today = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd');
        const defaults = {
            fromDate: today,
            toDate: today,
            dateIndex: 1,
            doctorName: [],
            serviceType: [],
            serviceNames: [],
            ModuleType: [],
            patientType: [],
            isSharable: false
        };
        const update = { ...(hasFilter ? filterDetails : defaults) };
        setStates(prev => ({
            ...prev,
            isLoader: true,
            ...update,
        }));
        getServiceConsolidateReport(update);
        getDoctorNameList();
        getModuleList();
    }, [JSON.stringify(history?.location?.state)])

    const getDoctorNameList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === "success") {
                        setStates((prev) => ({
                            ...prev,
                            doctorList: response.data.data ?? []
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error);
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getModuleList = async () => {
        try {
            let serviceTypes = [];
            let headServiceMap = {};

            const response = await RestAPIService.getAll(Serviceurls.NEW_SERVICE_LIST_REPORT);

            if (response?.data?.status === 'success') {
                const ModuleData = response.data.data || {};

                let uniqueHeads = new Set();

                Object.keys(ModuleData).forEach(moduleType => {

                    ModuleData[moduleType].forEach(({ head_name, service_details }) => {
                        if (!uniqueHeads.has(head_name)) {
                            uniqueHeads.add(head_name);
                            serviceTypes.push({ head_name });
                        }

                        if (!headServiceMap[head_name]) {
                            headServiceMap[head_name] = new Set();
                        }

                        if (service_details) {
                            service_details.forEach(({ service_name }) => {
                                if (service_name) {
                                    headServiceMap[head_name].add(service_name);
                                }
                            });
                        }
                    });
                });

                const normalizedMap = Object.fromEntries(
                    Object.entries(headServiceMap).map(([k, v]) => [k, [...v]])
                );

                setStates((prev) => ({
                    ...prev,
                    serviceHeads: serviceTypes,
                    serviceHeadServiceMap: normalizedMap
                }));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "An unknown error occurred";
            errorMessage(errorMessage);
        }
    };

    const getServiceNameOptions = () => {
        const map = states.serviceHeadServiceMap || {};
        const selectedHeads = states.serviceType || [];
        let names = [];
        if (selectedHeads.length) {
            const seen = new Set();
            selectedHeads.forEach((h) => {
                (map[h.head_name] || []).forEach((n) => {
                    if (!seen.has(n)) {
                        seen.add(n);
                        names.push({ service_name: n });
                    }
                });
            });
        } else {
            const seen = new Set();
            Object.values(map).forEach((list) => {
                list.forEach((n) => {
                    if (!seen.has(n)) {
                        seen.add(n);
                        names.push({ service_name: n });
                    }
                });
            });
        }
        return names;
    };

    const getServiceConsolidateReport = (paramsData) => {
        try {
            const { fromDate, toDate, doctorName, serviceType, serviceNames, ModuleType, patientType, isSharable } = paramsData || states;
            setStates((prev) => ({
                ...prev,
                isLoader: true
            }))
            let DocId = doctorName?.map((doc) => doc.doctor_id).join(',');
            let ServiceData = serviceType?.map((service) => service.head_name).join(',');
            let ServiceName = encodeURIComponent(serviceNames?.map((s) => s.service_name).join(',') || '');
            let moduleType = ModuleType?.map((mod) => mod.value).join(',');
            let Type = !patientType || patientType.length === 0 ? ['Outpatient','Inpatient','Individual'] : patientType?.map((type) => type.value).join(',');
            let params = `?from_date=${fromDate}&to_date=${toDate}&view_type=&doctor_id=${DocId}&module_type=${moduleType}&service_type=${ServiceData}&service_name=${ServiceName}&patient_type=${Type}&is_sharable=${isSharable}`
            RestAPIService.getAll(Serviceurls.DOCTOR_SERVICE_CONSOLIDATE + params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({
                            ...prev,
                            ServiceConsolidateData: response?.data?.data?.data ?? [],
                            total_amount: response?.data?.data?.Total_amount_card ?? 0,
                            total_doc_share: response?.data?.data?.Doctor_share_card ?? 0,
                            isLoader: false
                        }))
                    }
                }).catch(error => {
                    setStates((prev) => ({ ...prev, isLoader: false }))
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({ ...prev, isLoader: false }))
            errorMessage(error.message)
        }
    }
    const validateServiceData = () => {
        if (!states?.ServiceConsolidateData?.length) {
            errorMessage("No data found");
            return false;
        }
        return true;
    };
    const ServiceConsolidateOverviewPrint = () => {
        try {
            if (!validateServiceData()) return;
            const { fromDate, toDate, doctorName, serviceType, serviceNames, ModuleType, patientType, isSharable } = states;
            setStates((prev) => ({
                ...prev,
                isLoader: true
            }))
            let DocId = doctorName?.map((doc) => doc.doctor_id).join(',');
            let ServiceData = serviceType?.map((service) => service.head_name).join(',');
            let ServiceName = serviceNames?.map((s) => s.service_name).join(',') || '';
            let moduleType = ModuleType?.map((mod) => mod.value).join(',');
            let Type = !patientType || patientType.length === 0 ? ['Outpatient','Inpatient','Individual'] : patientType?.map((type) => type.value).join(',');
            let params = `?from_date=${fromDate}&to_date=${toDate}&view_type=&doctor_id=${DocId}&module_type=${moduleType}&service_type=${ServiceData}&service_name=${ServiceName}&patient_type=${Type}&is_sharable=${isSharable}&export_type=pdf`
            RestAPIService.getAll(Serviceurls.DOCTOR_SERVICE_CONSOLIDATE + params)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates((prev) => ({
                        ...prev,
                        isLoader: false
                    }))
                }).catch(error => {
                    setStates((prev) => ({
                        ...prev,
                        isLoader: false
                    }))
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({
                ...prev,
                isLoader: false
            }))
            errorMessage(error.message)
        }
    }

    const ServiceConsolidateDetailedExcel = () => {
        try {
            if (!validateServiceData()) return;
            const { fromDate, toDate, doctorName, serviceType, serviceNames, ModuleType, patientType, isSharable } = states;
            setStates((prev) => ({
                ...prev,
                isLoader: true
            }))
            let DocId = doctorName?.map((doc) => doc.doctor_id).join(',');
            let ServiceData = serviceType?.map((service) => service.head_name).join(',');
            let ServiceName = serviceNames?.map((s) => s.service_name).join(',') || '';
            let moduleType = ModuleType?.map((mod) => mod.value).join(',');
            let Type = !patientType || patientType.length === 0 ? ['Outpatient','Inpatient','Individual'] : patientType?.map((type) => type.value).join(',');
            let params = `?from_date=${fromDate}&to_date=${toDate}&view_type=&doctor_id=${DocId}&module_type=${moduleType}&service_type=${ServiceData}&service_name=${ServiceName}&patient_type=${Type}&is_sharable=${isSharable}&export_type=excel`
            RestAPIService.excelGet(Serviceurls.DOCTOR_SERVICE_CONSOLIDATE + params)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"]?.split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'Doctor Wise Service Consolidate Report.xlsx');
                        pom.click();
                        setStates((prev) => ({
                            ...prev,
                            isLoader: false
                        }))
                    }
                }).catch((error) => {
                    setStates((prev) => ({
                        ...prev,
                        isLoader: false
                    }))
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({
                ...prev,
                isLoader: false
            }))
            errorMessage(error?.message)
        }
    }

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(states.fromDate) },
            { label: "To Date", value: formatDate(states.toDate) },
        ]
        return (
            <Box><CommonGridToolBarWithFilterText FilterTextArray={TextArray} /></Box>

        )
    }

    const renderTable = () => {
        states?.ServiceConsolidateData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'bill_doctor', headerName: 'Doctor Name', flex: 0.25,
                renderCell: (params) => {
                    let DoctorName = params?.row?.bill_doctor
                    return (
                        <Box component={'div'}>
                            {DoctorName ? DoctorName?.length > 27 ?
                                <Tooltip placement='top' title={DoctorName}><Typography>{DoctorName?.slice(0, 27) + '...'}</Typography></Tooltip> :
                                <Typography>{DoctorName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'module_type', headerName: 'Module Type', flex: 0.15,
                renderCell: (params) => {
                    let ModuleType = params?.row?.module_type === "IP_OP" ? "OP & IP" : params?.row?.module_type
                    return (
                        <Box component={'div'}>
                            {ModuleType ? ModuleType?.length > 15 ?
                                <Tooltip placement='top' title={ModuleType}><Typography>{ModuleType?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography>{ModuleType}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'service_head', headerName: 'Service Head', flex: 0.25,
                renderCell: (params) => {
                    let ServiceHead = params?.row?.service_head
                    return (
                        <Box component={'div'}>
                            {ServiceHead ? ServiceHead?.length > 40 ?
                                <Tooltip placement='top' title={ServiceHead}><Typography>{ServiceHead?.slice(0, 40) + '...'}</Typography></Tooltip> :
                                <Typography>{ServiceHead}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'count', headerName: 'Count', flex: 0.1, headerAlign: 'center', align: "center",
                renderCell: (params) => {
                    let count = params?.row?.count
                    return (
                        <Box component={'div'}>
                            {count ? count?.length > 60 ?
                                <Tooltip placement='top' title={count}><Typography>{count?.slice(0, 60) + '...'}</Typography></Tooltip> :
                                <Typography>{count}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'total_amount', headerName: 'Total Amount', flex: 0.1, headerAlign: 'right', align: "right", type: 'number',
                renderCell: (params) => {
                    let amount = params?.row?.total_amount
                    return (
                        <Box component={'div'}>
                            {amount ? amount?.length > 15 ?
                                <Tooltip placement='top' title={amount}><Typography>{amount?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography>{amount}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'doctor_share', headerName: 'Doctor Share', flex: 0.1, headerAlign: 'right', align: "right", type: 'number',
                renderCell: (params) => {
                    let amount = params?.row?.doctor_share
                    return (
                        <Box component={'div'}>
                            {amount ? amount?.length > 15 ?
                                <Tooltip placement='top' title={amount}><Typography>{amount?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography>{amount}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.05,
                renderCell: (params) => {
                    let data = params?.row
                    return (
                        <Box component={'div'}>
                            <Tooltip placement='top' title='Detailed View'>
                                <Button className="Common_Btn_Min_Width"
                                    onClick={() => {
                                        history?.push({
                                            pathname: '/FOReports/PatientReport/ServiceConsolidateReport/detailed',
                                            state: {
                                                fromIPReport: false,
                                                serviceData: data,
                                                filterData: {
                                                    fromDate: states.fromDate,
                                                    toDate: states.toDate,
                                                    dateIndex: states.dateIndex,
                                                    doctorName: states.doctorName,
                                                    serviceType: states.serviceType,
                                                    serviceNames: states.serviceNames,
                                                    ModuleType: states.ModuleType,
                                                    patientType: states.patientType,
                                                    isSharable: states.isSharable
                                                }
                                            }
                                        })
                                    }}
                                >
                                    <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5vw'} width={'1.5vw'} />
                                </Button>
                            </Tooltip>
                        </Box>
                    )
                }
            },
        ]
        return (
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={states.ServiceConsolidateData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={states.page}
                    pageSize={states.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setStates((prev) => ({ ...prev, page: newPage })) }}
                    onPageSizeChange={(newPageSize) => setStates((prev) => ({ ...prev, pageSize: newPageSize }))}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={states.isLoader}
                />
            </Box>
        )
    }

    const closeFilter = () => {
        setStates((prev) => ({ ...prev, FilterOpen: false }))
    }

    const FilterDate = (from, to, index) => {
        setStates((prev) => ({
            ...prev,
            fromDate: from,
            toDate: to,
            dateIndex: index
        }))
    }

    const formatLabel = (text = "") => (text === 'OP' || text === 'IP' || text === 'OP & IP' ? text : text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()));

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{("Filter")}</Typography>
                    <Button onClick={() => { setStates((prev) => ({ ...prev, FilterOpen: false })) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={states.fromDate}
                            ToDate={states.toDate}
                            DateIndex={states.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={true} />
                    </Box>
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size="small"
                        sx={{ width: '21vw', mb: '1vw' }}
                        options={states.doctorList}
                        getOptionLabel={(option) => option.doctor_name}
                        value={states.doctorName}
                        onChange={(event, newValue) => {
                            setStates((prev) => ({ ...prev, doctorName: newValue }))
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Select Doctor Name"}
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        sx={{ width: '21vw', mb: '1vw' }}
                        options={PatientTypeList?.map((item) => item)}
                        getOptionLabel={(option) => (option?.patient_type)}
                        value={states.patientType}
                        onChange={(event, newValue) => {
                            setStates((prev) => ({ ...prev, patientType: newValue }))
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={'Select Patient Type'}
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        sx={{ width: '21vw', mb: '1vw' }}
                        options={ModuleTypeList()}
                        getOptionLabel={(option) => typeof option === 'string' ? formatLabel(option) : formatLabel(option?.patient_type)}
                        value={states.ModuleType}
                        onChange={(_, newValue) => {
                            setStates((prev) => ({ ...prev, ModuleType: newValue }))
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={'Select Module Type'}
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        sx={{ width: '21vw', mb: '1vw' }}
                        options={states.serviceHeads}
                        getOptionLabel={(option) => (option.head_name)}
                        value={states.serviceType}
                        onChange={(event, newValue) => {
                            setStates((prev) => ({ ...prev, serviceType: newValue, serviceNames: [] }))
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Select Service Head"}
                            />
                        )}
                    />
                    <Autocomplete
                        multiple
                        limitTags={1}
                        size='small'
                        sx={{ width: '21vw' }}
                        options={getServiceNameOptions()}
                        getOptionLabel={(option) => (option.service_name)}
                        isOptionEqualToValue={(option, value) => option.service_name === value.service_name}
                        value={states.serviceNames}
                        onChange={(event, newValue) => {
                            setStates((prev) => ({ ...prev, serviceNames: newValue }))
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Select Service Name"}
                            />
                        )}
                    />
                    <Box sx={{ mt: '1rem' }}>
                        <FormControlLabel
                            control={
                                <Checkbox size="small"
                                    checked={states.isSharable}
                                    onChange={(e) => {
                                        setStates((prev) => ({ ...prev, isSharable: e.target.checked }))
                                    }}
                                />
                            }
                            label={"Only Shared Services"}
                        />
                    </Box>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button variant='outlined' size="small" sx={{ mr: '1rem' }}
                        onClick={() => {
                            const today = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
                            const cleared = {
                                fromDate: today,
                                toDate: today,
                                dateIndex: 1,
                                doctorName: [],
                                serviceType: [],
                                serviceNames: [],
                                ModuleType: [],
                                patientType: [],
                                isSharable: false
                            }
                            setStates((prev) => ({ ...prev, ...cleared }))
                            getServiceConsolidateReport(cleared)
                        }}
                        id="eMed_Config_btn">{("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            setStates((prev) => ({ ...prev, FilterOpen: false }))
                            getServiceConsolidateReport()
                        }}
                        id="eMed_Config_btn">{("Search")}</Button>
                </Box>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '80dvh', backgroundColor: Colors.Background }}>
            <Box component={"div"} className='eMed_Top_Container'>
                <Box component={"div"} className='eMed_Cards_Container'>
                    {AmountsCard(("Total Amount"), states.total_amount)}
                    {AmountsCard(("Total Doctor Share"), states.total_doc_share)}
                </Box>
                <Box component={"div"} className='eMed_Action_Container' sx={{ width: '100%' }}>
                    <Button
                        variant='contained'
                        color="secondary"
                        startIcon={<img style={{width:'1.4vw', height:'1.4vw'}} src={ImagePaths.PrintIcon.default} alt="print" />}
                        onClick={() => ServiceConsolidateOverviewPrint()}
                        size="small"
                        sx={{ marginRight: "0.5vw" }}
                    >
                        Summary Print
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<img src={ImagePaths.down.default} alt="print" />}
                        onClick={() => ServiceConsolidateDetailedExcel()}
                        size="small"
                        sx={{ marginRight: "0.5vw" }}
                    >
                        Detailed Excel
                    </Button>
                    <Box component={"div"} className='eMed_Filter_Icon_div'>
                        <Button className='eMed_usrconf_btn' onClick={() => { setStates((prev) => ({ ...prev, FilterOpen: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Box>
                </Box>
            </Box>
            {renderTable()}
            <Drawer
                anchor={'right'}
                open={states.FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default ServiceConsolidateReport